import React from "react";

const awards = [
  {
    title: "Eco-Friendly Company",
    year: "2024",
    desc: "Recognised for using sustainable materials, low-VOC paints and energy-efficient installations across every renovation project we deliver.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4 14C4 8 9 4 14 4h6v6c0 5-4 10-10 10H4v-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round"/>
        <path d="M4 20C9 14 14 10 20 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    title: "Best Quality Work in Malaysia",
    year: "2023",
    desc: "Awarded for consistently delivering exceptional craftsmanship and customer satisfaction across handyman and home renovation projects nationwide.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M7 4h10v3a5 5 0 0 1-5 5 5 5 0 0 1-5-5V4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
        <path d="M17 4h3v2a3 3 0 0 1-3 3M7 4H4v2a3 3 0 0 0 3 3M10 20h4M12 12v8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: "Zero Noise Pollution Certification",
    year: "2024",
    desc: "Certified for using low-noise equipment and scheduling-friendly workflows that respect residential and commercial neighbours during renovation work.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M11 5 6 9H3v6h3l5 4V5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
        <path d="m17 9 4 6M21 9l-4 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    title: "Customer Excellence Award",
    year: "2025",
    desc: "Honoured for outstanding client service, on-time project delivery and a 5-star satisfaction rating from homeowners across Kuala Lumpur and Selangor.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="m12 3 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.6 9.8l6.5-.9L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

const AwardsArea = () => {
  return (
    <section id="awards" className="awards-area pt-100 pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="section-title text-center mb-60">
              <span className="sub-title">Our Recognitions</span>
              <h2 className="title">
                Awards Received by FRG Renovation Works
              </h2>
              <p className="awards-intro">
                Independent industry bodies and Malaysian homeowners have recognised our commitment to quality, sustainability and responsible work practices.
              </p>
            </div>
          </div>
        </div>

        <div className="row awards-grid">
          {awards.map((a, i) => (
            <div key={i} className="col-lg-3 col-md-6">
              <article className="award-card" style={{ animationDelay: `${i * 120}ms` }}>
                <div className="award-card__year">{a.year}</div>
                <div className="award-card__icon">{a.icon}</div>
                <h3 className="award-card__title">{a.title}</h3>
                <p className="award-card__desc">{a.desc}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsArea;
